import React from 'react';
import { Sidebar } from '@/components/Sidebar';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { RequireAuth } from '@/components/auth/RequireAuth';
import { RequireAppAccess } from '@/components/auth/RequireAppAccess';
import { BackToTop } from '@/components/common/BackToTop';
import { useSidebar } from '@/contexts/SidebarContext';
import { Outlet, useLocation } from 'react-router-dom';

// Use React.memo to prevent unnecessary rerenders
const AppLayoutContent = React.memo(function AppLayoutContent() {
  const { isCollapsed, isMobile, isMobileOpen, closeMobileSidebar } = useSidebar();
  const location = useLocation();
  const isWideWorkspace = location.pathname.startsWith('/vendors');

  return (
    <div className="min-h-screen bg-gray-100 overflow-x-hidden flex flex-col">
      <div className="flex flex-1">
        <Sidebar />
        {isMobile && isMobileOpen && (
          <button
            type="button"
            aria-label="Close navigation menu"
            onClick={closeMobileSidebar}
            className="fixed inset-y-0 left-64 right-0 z-30 bg-slate-950/30 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500"
          />
        )}
        <div className={`flex min-w-0 flex-1 flex-col transition-all duration-300 ${isMobile ? 'ml-20' : isCollapsed ? 'ml-20' : 'ml-64'}`}>
          <Header />
          <main className={`p-4 sm:p-6 mx-auto w-full min-w-0 flex-1 ${isWideWorkspace ? 'max-w-[1600px]' : 'max-w-7xl'}`}>
            <Outlet />
          </main>
          <Footer />
        </div>
      </div>
      <BackToTop />
    </div>
  );
});

export function AppLayout() {
  return (
    <RequireAuth>
      <RequireAppAccess>
        <AppLayoutContent />
      </RequireAppAccess>
    </RequireAuth>
  );
}
